var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import srciLogicSdk from "@payair/srci-logic-sdk";
import { ResultStatusObj } from "@payair/srci-logic-sdk/models/ResultStatus";
import { DcfSdkEnumsObj } from "../../enums/DcfSdkEnum";
import { SrciEventTypeEnumsObj } from "../../enums/SrciEventTypeEnum";
import { MerchantRecognitionTokenStore } from "./MerchantRecognitionTokenStore";
var createRecognitionFailureResult = function (network) { return ({
    status: ResultStatusObj.REJECTED,
    reason: {
        reason: "RECOGNITION_FAILED",
        status: ResultStatusObj.REJECTED,
        message: "Recognition failed",
    },
    sdk: network,
}); };
/** @internal */
var MerchantRecognitionCoordinator = /** @class */ (function () {
    function MerchantRecognitionCoordinator(eventReporter, tokenStore, recognitionSdk) {
        if (tokenStore === void 0) { tokenStore = new MerchantRecognitionTokenStore(eventReporter); }
        if (recognitionSdk === void 0) { recognitionSdk = srciLogicSdk; }
        var _this = this;
        this.eventReporter = eventReporter;
        this.tokenStore = tokenStore;
        this.recognitionSdk = recognitionSdk;
        this.recognizeConsumer = function (supportedNetworks) { return __awaiter(_this, void 0, void 0, function () {
            var responses;
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all(supportedNetworks.map(function (network) { return __awaiter(_this, void 0, void 0, function () {
                            var recognitionToken, networkResponses, _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        recognitionToken = this.tokenStore.read(network);
                                        _c.label = 1;
                                    case 1:
                                        _c.trys.push([1, 6, , 7]);
                                        if (!recognitionToken) return [3 /*break*/, 3];
                                        return [4 /*yield*/, this.recognitionSdk.isRecognized({ recognitionTokens: [recognitionToken] }, network)];
                                    case 2:
                                        _a = _c.sent();
                                        return [3 /*break*/, 5];
                                    case 3: return [4 /*yield*/, this.recognitionSdk.isRecognized(network)];
                                    case 4:
                                        _a = _c.sent();
                                        _c.label = 5;
                                    case 5:
                                        networkResponses = _a;
                                        return [3 /*break*/, 7];
                                    case 6:
                                        _b = _c.sent();
                                        return [2 /*return*/, [createRecognitionFailureResult(network)]];
                                    case 7:
                                        if (recognitionToken &&
                                            networkResponses.some(function (response) { var _a; return response.status === ResultStatusObj.FULFILLED && ((_a = response.value) === null || _a === void 0 ? void 0 : _a.recognized) === false; })) {
                                            this.remove(network);
                                        }
                                        return [2 /*return*/, networkResponses];
                                }
                            });
                        }); }))];
                    case 1:
                        responses = _b.sent();
                        return [2 /*return*/, (_a = []).concat.apply(_a, responses)];
                }
            });
        }); };
        // The concrete store reports expected failures without throwing; these guards keep flows safe if an injected
        // implementation violates that contract.
        this.persistRecognitionToken = function (token, network, rememberMe) {
            if (!rememberMe) {
                if (token !== undefined) {
                    _this.reportStorageError(network, "UNEXPECTED_TOKEN");
                }
                return;
            }
            try {
                _this.tokenStore.write(network, token);
            }
            catch (_a) {
                _this.reportStorageError(network, "COOKIE_WRITE_FAILED");
            }
        };
        this.clearAll = function () {
            try {
                _this.tokenStore.removeAll();
            }
            catch (_a) {
                _this.reportStorageError(DcfSdkEnumsObj.VISA, "COOKIE_DELETE_FAILED");
                _this.reportStorageError(DcfSdkEnumsObj.MASTERCARD, "COOKIE_DELETE_FAILED");
            }
        };
        this.remove = function (network) {
            try {
                _this.tokenStore.remove(network);
            }
            catch (_a) {
                _this.reportStorageError(network, "COOKIE_DELETE_FAILED");
            }
        };
        this.reportStorageError = function (network, reason) {
            try {
                _this.eventReporter.sendEvent(SrciEventTypeEnumsObj.RECOGNITION_TOKEN_STORAGE_ERROR, { network: network, reason: reason });
            }
            catch (_a) {
                // Storage diagnostics must not affect checkout or identity-reset flows.
            }
        };
    }
    return MerchantRecognitionCoordinator;
}());
export { MerchantRecognitionCoordinator };
